import {
  getStaticAssetUrl,
  StaticAssetType,
} from '../../../common/shared/utils/getStaticAssetUrl';
import {Image} from '../../atoms/Image/Image';
import {STATIC_IMAGE_INFO_MAP} from '../../atoms/StaticImage/StaticImageInfoMap.constant';
import {StaticImageType} from '../../atoms/StaticImage/StaticImageType.enum';

interface ProfileImageProps {
  thumbnailUrl: string;
  className?: string;
}

export function ProfileImage({thumbnailUrl, className}: ProfileImageProps) {
  return (
    <Image
      src={thumbnailUrl}
      alt="프로필"
      ratio={1}
      className={className}
      onError={event => {
        if (STATIC_IMAGE_INFO_MAP[StaticImageType.ProfileStatic].srcStatic) {
          const fallbackImg = getStaticAssetUrl(
            STATIC_IMAGE_INFO_MAP[StaticImageType.ProfileStatic].srcStatic,
            StaticAssetType.Image
          );
          event.currentTarget.src = fallbackImg;
        }
      }}
    />
  );
}
